import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./ProgressChart.css";

const ProgressChart = ({ productData }) => {
  const dataToUse = Array.isArray(productData) ? productData : [];

  const formattedCategories = dataToUse.map((item) => item.class_name);

  // Yield calculator
  const getYield = (passed, produced) => {
    const num = parseFloat(passed);
    const denom = parseFloat(produced);

    if (!denom || isNaN(num) || isNaN(denom)) return 0;

    const val = (num / denom) * 100;

    if (!isFinite(val)) return 0;

    return parseFloat(val.toFixed(2));
  };

  // Series data
  const producedData = dataToUse.map((item) => item.produced || 0);
  const passedData = dataToUse.map((item) => item.passed || 0);
  const rejectedData = dataToUse.map((item) =>
   item.rejected
 );
  const percentageLabels = dataToUse.map(
    (item) => `${getYield(item.passed, item.produced)}%`
  );

  const barHeight = 23;
  const barGap = 15;
  const chartHeight = dataToUse.length * (barHeight + barGap) + 50;

  const options = useMemo(
    () => ({
      chart: {
        type: "bar",
        height: chartHeight,
        spacingTop: 10,
        spacingBottom: 10,
      },
      title: { text: "" },
      xAxis: [
        {
          categories: formattedCategories,
          labels: {
            className: "products-chart-label",
            align: "right",
            x: -10,
            y: 3,
            reserveSpace: true,
          },
          lineWidth: 0,
          offset: 0,
        },
        {
          opposite: true,
          linkedTo: 0,
          categories: percentageLabels,
          labels: {
            formatter: function () {
              return this.value;
            },
            className: "products-chart-label-bold",
            align: "left",
            x: 5,
            y: 3,
            reserveSpace: true,
          },
          lineWidth: 0,
          offset: 0,
        },
      ],
      yAxis: {
        min: 0,
    
        title: { text: null },
        labels: { enabled: false },
        gridLineWidth: 0,
        lineWidth: 0,
      },
      plotOptions: {
        series: {
          stacking: "percent",
          pointHeight: barHeight,
          pointPadding: 0,
          groupPadding: 0.2,
          borderRadius: 10,
        },
        bar: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      legend: { enabled: false },
      credits: { enabled: false },
      tooltip: {
        formatter: function () {
          const data = dataToUse[this.point.index];
          if (this.series.name === "Produced") {
            return `<b>Produced:</b> ${data?.produced || 0}`;
          } else if (this.series.name === "Passed") {
            return `<b>Passed:</b> ${data?.passed || 0} 
                    (${getYield(data?.passed, data?.produced)}%)`;
          } else if (this.series.name === "Rejected") {
            return `<b>Rejected:</b> ${data?.rejected || 0} 
                    (${getYield(data?.passed, data?.produced)}%)`;
          }
          return null;
        },
      },
      series: [
        {
          name: "Rejected",
          data: rejectedData,
          color: "#e31e24",
          borderRadius: { radius: 50, scope: "stack" },
              
        },
        {
          name: "Passed",
          data: passedData,
          color: "#00ab66",
          borderRadius: { radius: 50, scope: "stack" },
          
        },
        {
          name: "Produced",
          data: producedData,
          color: "#1c407b",
          borderRadius: { radius: 50, scope: "stack" }, // Rounded corners
          
        },
        
       
      ],
      
    }),
    [productData]
  );

  return (
    <div className="scroll-container-left-scrollbar">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ProgressChart;